<template>
	<div class="empty-state">
		<component :is="icon" halo />
		<slot name="text">
			{{ text }}
		</slot>
		<slot name="button">
			<Button v-bind="buttonProps" primary @click="$emit('click', $event)">
				{{ buttonText }}
			</Button>
		</slot>
	</div>
</template>

<script>
import { Button } from '@/components/common'

export default {
	name: 'EmptyState',
	components: { Button },
	props: {
		icon: null,
		text: String,
		buttonText: String,
		buttonProps: Object,
	},
	emits: ['click'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.empty-state {
	@include flex-column-center;
	.pronto-icon {
		font-size: 75px;
		color: var(--blue-300);
		margin-bottom: 24px;
	}
	:deep(.pronto-btn) {
		margin-top: 24px;
	}
}
</style>
